module.exports = __webpack_public_path__ + "img/sm_edit_icon.e27f0869.svg";